<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.reportsPartners')}}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 text-md-right text-xs-right>
				<v-tooltip bottom>
				<v-btn @click="excelExport" icon slot="activator">
					<v-icon small>fa-file-excel</v-icon>
				</v-btn>
				<span>{{$t('tooltips.excel')}}</span>
			</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-3>
			<v-flex xs12>
				<DataTableContacts
						:excel="false"
						:filter="false"
						:headers="contactsTable.headers"
						:items="contactsTable.items"
						:total="contactsTable.total"
						@reload="reloadData"
						@excel="excelExport"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}">
								<td>{{ props.item.partner_name }}</td>
								<td>{{ props.item.client_no }}</td>
								<td>{{ props.item.buyers_no }}</td>
								<td>{{ props.item.realestate_no }}</td>
							</tr>
						</template>
					</DataTableContacts>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTableContacts from "./trinkets/DataTableContacts";
import InputField from "./trinkets/InputField";

export default {
	name: "ReportsPartners",
	components: {DataTableContacts, InputField},
	data: function () {
		return {
			contactsTable: {
				headers: [
					{text: this.$t('fields.partner'), value: 'partner_name', type: 'string', searchable: false},
					{text: this.$t('fields.clientNo'), value: 'client_no', type: 'string', searchable: false},
					{text: this.$t('fields.buyersNo'), value: 'buyers_no', type: 'string', searchable: false},
					{text: this.$t('fields.realeastateNo'), value: 'realestate_no', type: 'string', searchable: false},
				],
				items: [],
				total: 0,
				lastRequest: null
			}
		}
	},
	methods: {
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'report-partners', request, (data, success) => {
				if (success) {
					vm.contactsTable.items = data.items;
					vm.contactsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		excelExport() {
			if(this.contactsTable.items != undefined && this.contactsTable.items != null){
				if(this.contactsTable.items.length != 0){
					this.$APICall('post', 'excel/report-partners', this.contactsTable.items, (data, success) => {
						window.open(data.link);
					});
				}
			}
		},
		editClick(link){
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
		this.reloadData();
	}
}
</script>

<style scoped>

</style>
